import { useQuery, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '../../utils/axios';
import useUserStore from '../../store/main/useUserStore';

interface UserResponse {
  data: {
    id: string;
  } | null;
}

export const USER_QUERY_KEY = ['user'] as const;

export const useUser = () => {
  const queryClient = useQueryClient();
  const setUser = useUserStore((state) => state.setLoginUser);

  const query = useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: async () => {
      try {
        const response = await axiosInstance.get<UserResponse>('/m/user');
        const userData = response.data?.data || null;
        setUser(userData);
        return userData;
      } catch (error) {
        console.error('Error fetching user data:', error);
        setUser(null);
        return null;
      }
    },
  });

  return {
    ...query,
    refreshUser: () =>
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY }),
  };
};
